"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpenShipmentStatuses = getOpenShipmentStatuses;
exports.getTerminalShipmentStatuses = getTerminalShipmentStatuses;
const business_types_1 = require("@deliverr/business-types");
function getOpenShipmentStatuses() {
    return [
        business_types_1.WarehouseShipmentStatus.CREATED,
        business_types_1.WarehouseShipmentStatus.ON_HOLD,
        business_types_1.WarehouseShipmentStatus.PROCESSING,
        business_types_1.WarehouseShipmentStatus.READY_TO_SHIP,
        business_types_1.WarehouseShipmentStatus.PARTIALLY_SHIPPED,
    ];
}
function getTerminalShipmentStatuses() {
    return [business_types_1.WarehouseShipmentStatus.SHIPPED, business_types_1.WarehouseShipmentStatus.CANCELLED];
}
//# sourceMappingURL=ShipmentStatusResponse.js.map